import React, { createContext, useContext } from 'react'
import { usePushNotification } from '@/hooks/use-push-notification'
import type { PushNotificationContextValue } from '@/models/push-notification'

export const PushNotificationContext = createContext<PushNotificationContextValue>({
  permission: 'default',
  isSubscribed: false,
  isInitializing: true,
  subscribe: async () => {},
  unsubscribe: async () => {},
})

export const PushNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = usePushNotification()

  return <PushNotificationContext.Provider value={value}>{children}</PushNotificationContext.Provider>
}

/** Push 通知の状態と操作を取得する */
export const usePushNotificationContext = () => useContext(PushNotificationContext)
